import styles from './Tabs.module.css';

interface TabsProps {
  setCurrentTab: TypeAny;
  currentTab: string;
  tabs: {
    value: string;
    count: number;
    key: string;
  }[];
}

export function Tabs({ tabs, currentTab, setCurrentTab }: TabsProps) {
  if (!tabs.length) return null;

  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          data-is-active={currentTab === tab.key}
          onClick={() => setCurrentTab(tab.key)}
          className={styles.tabsButton}
          key={`tab-${tab.key}`}
          type="button"
        >
          {tab.value}

          <span className={styles.tabsCount}>{tab.count}</span>
        </button>
      ))}
    </div>
  );
}
